import CRUD from './CRUD';

/**
 * Provides a set of CRUD operations around API: /credentials
 */
export default class CredentialsClient extends CRUD {
	constructor() {
		super('/credentials');
	}
}

